export default __webpack_public_path__ + "static/RaniyahCopeland-684a4e4bf972b6fb85ada98c629e2445.jpg";